// extracted by mini-css-extract-plugin
module.exports = {"container":"victoryFeed_container__1Edwm","more":"victoryFeed_more__3d12k","victories":"victoryFeed_victories__1rqti"};